import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import logo from "../img/logo.png";
import Cookies from "universal-cookie";
import UserMenu from "./UserMenu";
import OutsideClickHandler from "react-outside-click-handler";

const MENU_ITEMS = [
  {
    label: "La Empresa",
    href: "#",
    children: [
      {
        label: "Quiénes Somos",
        href: "https://elrodeo.muumercadoganadero.com/empresa#quienes-somos",
      },
      { label: "Visión", href: "https://elrodeo.muumercadoganadero.com/empresa#vision" },
      { label: "Misión", href: "https://elrodeo.muumercadoganadero.com/empresa#mision" },
      { label: "Valores", href: "https://elrodeo.muumercadoganadero.com/empresa#valores" },
      { label: "Contactos", href: "https://elrodeo.muumercadoganadero.com/empresa#contactos" },
    ],
  },
  {
    label: "Reproductores",
    href: "#",
    children: [
      {
        label: "Ferias Especiales",
        href: "https://elrodeo.muumercadoganadero.com/reproductores/ferias",
      },
      {
        label: "Subasta Online",
        href: "https://elrodeo.muumercadoganadero.com/reproductores/subasta-online",
      },
      {
        label: "Venta Directa",
        href: "https://elrodeo.muumercadoganadero.com/reproductores/venta-directa",
      },
    ],
  },
  {
    label: "Invernada",
    href: "#",
    children: [
      {
        label: "Ferias Especiales",
        href: "https://elrodeo.muumercadoganadero.com/invernada/ferias",
      },
      {
        label: "Subasta Online",
        href: "https://elrodeo.muumercadoganadero.com/invernada/subasta-online",
      },
      {
        label: "Venta Directa",
        href: "https://elrodeo.muumercadoganadero.com/invernada/venta-directa",
      },
    ],
  },
  {
    label: "Faena",
    href: "#",
    children: [{ label: "Estadísticas", href: "/" }],
  },
  {
    label: "Propiedades Rurales",
    href: "#",
    children: [
      { label: "Venta", href: "https://elrodeo.muumercadoganadero.com/propiedades-rurales/venta" },
      {
        label: "Compra",
        href: "https://elrodeo.muumercadoganadero.com/propiedades-rurales/compra",
      },
      {
        label: "Capitalizaciones",
        href: "https://elrodeo.muumercadoganadero.com/propiedades-rurales/capitalizaciones",
      },
      {
        label: "Alquiler",
        href: "https://elrodeo.muumercadoganadero.com/propiedades-rurales/alquiler",
      },
    ],
  },
  {
    label: "Galería",
    href: "https://elrodeo.muumercadoganadero.com/galeria",
  },
];

const Header = (props) => {
  const loggedIn = props.logged;
  const cookies = new Cookies();
  const usuarioCookie = cookies.get("user") ? cookies.get("user")[0] : "?";

  const [userMenuButton, setUserMenuButton] = useState(false);
  const [hamburgerMenu, setHamburgerMenu] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handlerMenu = () => {
    setHamburgerMenu(!hamburgerMenu);
  };

  const userMenu = () => {
    setUserMenuButton(!userMenuButton);
  };

  const closeMenu = () => {
    setHamburgerMenu(false);
  };

  return (
    <div className="header-topbar-area two">
      <header className="header-area style-4">
        {/* LADO IZQUIERDO: Logo y Menú */}
        <div className="nav-left">
          <div className="company-logo">
            <Link to="/">
              <img
                alt="El Rodeo"
                className="img-fluid"
                width="145px"
                style={{ padding: "5px 0" }}
                src={logo}
              />
            </Link>
          </div>

          <div className={`main-menu ${hamburgerMenu ? "show-menu" : ""}`}>
            <div className="mobile-menu-head">
              <div className="mobile-logo">
                <Link to="/" onClick={closeMenu}>
                  <img alt="El Rodeo" src={logo} width="120px" />
                </Link>
              </div>
              <div className="mobile-menu-close" onClick={closeMenu}>
                &times;
              </div>
            </div>

            <ul className="menu-list">
              {MENU_ITEMS.map((item, index) => (
                <li
                  key={item.label}
                  className="menu-item-container"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <a
                    href={item.href}
                    onClick={closeMenu}
                    className={`menu-link ${hoveredIndex === index ? "active" : ""}`}
                  >
                    {item.label}
                    {item.children && (
                      <ChevronDown
                        className={`menu-chevron ${hoveredIndex === index ? "rotate" : ""}`}
                      />
                    )}
                  </a>
                  {/* Submenú Desplegable con Animación */}
                  <AnimatePresence>
                    {hoveredIndex === index && item.children && (
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        className="dropdown-menu"
                      >
                        <div className="dropdown-content">
                          {item.children.map((child) => (
                            <a
                              key={child.label}
                              href={child.href}
                              onClick={closeMenu}
                              className="submenu-item"
                            >
                              {child.label}
                            </a>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* LADO DERECHO: Botón de Usuario / Menú Móvil */}
        <div className="nav-right">
          {!loggedIn ? (
            <div onClick={props.iniciarSesion || props.handleLogin} className="login-btn">
              <div className="icon">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    d="M18.0001 9.49996C18.0001 14.1944 14.1945 18 9.50004 18C4.80552 18 1 14.1944 1 9.49996C1 4.80543 4.80552 0.999913 9.50004 0.999913C14.1945 0.999913 18.0001 4.80543 18.0001 9.49996Z"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M12.9007 8.36671C12.9007 10.2445 11.3785 11.7667 9.50064 11.7667C7.62273 11.7667 6.10059 10.2445 6.10059 8.36671C6.10059 6.48897 7.62273 4.96672 9.50064 4.96672C11.3785 4.96672 12.9007 6.48897 12.9007 8.36671Z"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M4.42676 16.3221C4.69869 13.7615 6.86539 11.7667 9.49811 11.7667C12.1309 11.7667 14.2976 13.7616 14.5694 16.3222"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <span>Iniciar Sesión</span>
              <span className="bg-anim"></span>
            </div>
          ) : (
            <OutsideClickHandler onOutsideClick={() => setUserMenuButton(false)}>
              <div
                className="user-avatar-container"
                onClick={userMenu}
                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  className="navbar2_avatar"
                  style={{
                    background: "#19513c",
                    color: "white",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {usuarioCookie.charAt(0).toUpperCase()}
                </div>
                {userMenuButton && (
                  <UserMenu
                    loggedIn={loggedIn}
                    userMenu={userMenu}
                    userName={props.userName}
                    lastName={props.lastName}
                    handleLogout={props.handleLogout}
                  />
                )}
              </div>
            </OutsideClickHandler>
          )}

          <div className={`mobile-menu-btn ${hamburgerMenu ? "active" : ""}`} onClick={handlerMenu}>
            <span></span>
          </div>
        </div>

        {hamburgerMenu && (
          <div
            className="menu-overlay"
            onClick={closeMenu}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 98,
            }}
          ></div>
        )}
      </header>
    </div>
  );
};

export default Header;
